export default __webpack_public_path__ + "static/media/A24.3b1010b7.png";